<template>
    <div class="form-field">
        <label>内容</label>
        <div class="content">
            <input class="form-input" :value="content" @input="updateValue($event.target.value)"/>
        </div>
    </div>
</template>

<style lang="scss" scoped>

    .content {
        display: flex;
        > div {
            flex: 1;
            margin-right: 10px;
        }
        > input {
            padding: 0 10px;
        }
    }
</style>

<script>
	import style from 'mixins/style'

	export default {
		mixins: [ style ],
		computed: {
			style() {
				return this.$store.state.mask && this.$store.state.mask[ 0 ] && this.$store.state.mask[ 0 ].style || {}
			},
			selected() {
                return this.$store.state.selected||{}
			},
			scaleRate() {
				return this.$store.state.scaleRate||1
			},
			designWidth() {
				return this.$store.state.designWidth
			},
			designHeight() {
				return this.$store.state.designHeight
			},
			actions(){
				return this.$store.state.actions||[]
            },
			content() {
				return this.selected.content
			}
		},
		methods: {
			updateValue(value) {
				this.$store.commit('update_elm', {
					id: this.selected.id,
					data: {
						content: value
					}
				})
                this.$nextTick(()=>{
                	const id = this.selected.id
					const elm = document.querySelector('#'+id+' text')
                    const { x,y } = this.selected
					const act = this.actions.find(item=>item.element+ '_'+item.name === id)
                    const rect = elm.getBoundingClientRect()
                    const pos = `${x/this.designWidth},${y/this.designHeight},${(x+rect.width/this.scaleRate)/this.designWidth},${(y+rect.height/this.scaleRate)/this.designHeight}`
                    this.$store.commit('update_action', {
						name: act.name,
                        startPos: pos,
                        endPos: pos
					})
					this.$store.commit('update_element',{
						id: this.selected.id,
						data: {
							value
						}
					})
					this.$store.dispatch('video/updateElements')

					this.$nextTick(()=> {
						this.$store.dispatch('elm_select', {
							id: this.selected.id
						})
					})
                })
			}
		}
	}
</script>
